import { render, staticRenderFns } from "./Coupon.vue?vue&type=template&id=b2fc678a&scoped=true"
import script from "./Coupon.vue?vue&type=script&lang=js"
export * from "./Coupon.vue?vue&type=script&lang=js"
import style0 from "../../assets/styles/admin/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "../../assets/styles/checkBoxInput.css?vue&type=style&index=1&id=b2fc678a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2fc678a",
  null
  
)

export default component.exports